import React from 'react';
import { CustomTextField } from '../../widgets/CustomTextField';
import { EntityForm } from '../../widgets/Forms';
import ViewUtils from '../../ViewUtils';
import TabPanel, { FormTabContainer } from '../../widgets/TabPanel';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import AppBar from '@material-ui/core/AppBar';
import { SelectItem } from '../../widgets/SelectItem';

function a11yProps(index) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    };
}

const utils = new ViewUtils();
export const APPIndicatorForm = React.forwardRef((props, ref) => {
    const [tabValue, setTabValue] = React.useState(0);
    const handleTabChange = (event, newValue) => {
        setTabValue(newValue);
    };

    function DisabledCheck(value) {
        if (value !== undefined && value !== null) {
            if (value === "true") {
                return true
            }
            else {
                return false
            }
        }
    }

    return (
        <EntityForm ref={ref} viewId="projectdetails" values={props.data} dataURL='api/sims/APPMaintenance/GetFind'
            entityLookupController={props.entityLookupController} org="saseta"
            entityLookupId={props.id} useCustomSettings={false} valueChangeHandler={props.valueChangeHandler}>
            {form =>
                <form className={form.classes.container} id="ProjectDetailsForm">
                    <FormTabContainer>
                        <AppBar position="static" color="default" style={{ background: 'transparent', boxShadow: 'none', borderBottom: '1px solid #d1d1d1' }}>
                            <Tabs value={tabValue} onChange={handleTabChange} indicatorColor="primary" textColor="primary" aria-label="tabs">
                                <Tab label="APP Indicator Details" wrapped {...a11yProps(0)} style={{ color: form.fieldParentErrors[0] === true ? "red" : null }} />
                            </Tabs>
                        </AppBar>
                        <TabPanel className="w-100" value={tabValue} index={0}>
                            <table cellPadding="2" width="80%">
                                <tbody>
                                    <tr>
                                        <td>
                                            <SelectItem
                                                dataUrl="api/sims/APPMaintenance/GetLookupList?listId=APPProgrammeStructure"
                                                id="APPProgrammeStructureID"
                                                label="Programme Structure"
                                                className="w-150"
                                                form={form}
                                                InputProps={{
                                                    readOnly: props.disableFields
                                                }}
                                                disabled={DisabledCheck(form.values["NotEditable"])}
                                            />
                                        </td>
                                        <td>
                                            <CustomTextField
                                                id="IndicatorNo"
                                                key={tabValue}
                                                label="Ouput Indicator No"
                                                className="w-100"
                                                form={form}
                                                disabled={DisabledCheck(form.values["NotEditable"])}
                                            />
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <CustomTextField
                                                id="IndicatorName"
                                                key={tabValue}
                                                label="Ouput Indicator"
                                                className="w-100"
                                                form={form}
                                                disabled={DisabledCheck(form.values["NotEditable"])}
                                            />
                                        </td>
                                        <td>
                                            <CustomTextField
                                                id="ProjectID"
                                                key={tabValue}
                                                label="Project ID"
                                                className="w-100"
                                                form={form}
                                            />
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <CustomTextField
                                                id="AnnualTargets"
                                                key={tabValue}
                                                label="Annual Targets"
                                                className="w-100"
                                                form={form}
                                            />
                                        </td>
                                        <td>
                                            <SelectItem
                                                dataUrl="api/sims/APPMaintenance/GetLookupList?listId=APPCalculationType"
                                                id="CalculationTypeID"
                                                label="Calculation Type"
                                                className="w-150"
                                                form={form}
                                                InputProps={{
                                                    readOnly: props.disableFields
                                                }}
                                            />
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <CustomTextField
                                                id="Q1Target"
                                                key={tabValue}
                                                label="Q1 Target"
                                                className="w-100"
                                                form={form}
                                                required
                                            />
                                        </td>
                                        <td>
                                            <CustomTextField
                                                id="Q1Achievement"
                                                key={tabValue}
                                                label="Q1 Achievement"
                                                className="w-100"
                                                form={form}
                                                required
                                                disabled={DisabledCheck(form.values["NotEditable"])}
                                            />
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <CustomTextField
                                                id="Q1DeviationComment"
                                                key={tabValue}
                                                label="Q1 Comment on Deviation"
                                                className="w-100"
                                                form={form}
                                                required
                                            />
                                        </td>
                                        <td>
                                            <CustomTextField
                                                id="Q1MitigationPlan"
                                                key={tabValue}
                                                label="Q1 Mitigation Plan"
                                                className="w-100"
                                                form={form}
                                                required
                                            />
                                        </td>
                                    </tr>


                                    <tr>
                                        <td>
                                            <CustomTextField
                                                id="Q2Target"
                                                key={tabValue}
                                                label="Q2 Target"
                                                className="w-100"
                                                form={form}
                                                required
                                            />
                                        </td>
                                        <td>
                                            <CustomTextField
                                                id="Q2Achievement"
                                                key={tabValue}
                                                label="Q2 Achievement"
                                                className="w-100"
                                                form={form}
                                                required
                                                disabled={DisabledCheck(form.values["NotEditable"])}
                                            />
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <CustomTextField
                                                id="Q2DeviationComment"
                                                key={tabValue}
                                                label="Q2 Comment on Deviation"
                                                className="w-100"
                                                form={form}
                                                required
                                            />
                                        </td>
                                        <td>
                                            <CustomTextField
                                                id="Q2MitigationPlan"
                                                key={tabValue}
                                                label="Q2 Mitigation Plan"
                                                className="w-100"
                                                form={form}
                                                required
                                            />
                                        </td>
                                    </tr>


                                    <tr>
                                        <td>
                                            <CustomTextField
                                                id="Q3Target"
                                                key={tabValue}
                                                label="Q3 Target"
                                                className="w-100"
                                                form={form}
                                                required
                                            />
                                        </td>
                                        <td>
                                            <CustomTextField
                                                id="Q3Achievement"
                                                key={tabValue}
                                                label="Q3 Achievement"
                                                className="w-100"
                                                form={form}
                                                required
                                                disabled={DisabledCheck(form.values["NotEditable"])}
                                            />
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <CustomTextField
                                                id="Q3DeviationComment"
                                                key={tabValue}
                                                label="Q3 Comment on Deviation"
                                                className="w-100"
                                                form={form}
                                                required
                                            />
                                        </td>
                                        <td>
                                            <CustomTextField
                                                id="Q3MitigationPlan"
                                                key={tabValue}
                                                label="Q3 Mitigation Plan"
                                                className="w-100"
                                                form={form}
                                                required
                                            />
                                        </td>
                                    </tr>


                                    <tr>
                                        <td>
                                            <CustomTextField
                                                id="Q4Target"
                                                key={tabValue}
                                                label="Q4 Target"
                                                className="w-100"
                                                form={form}
                                                required
                                            />
                                        </td>
                                        <td>
                                            <CustomTextField
                                                id="Q4Achievement"
                                                key={tabValue}
                                                label="Q4 Achievement"
                                                className="w-100"
                                                form={form}
                                                required
                                                disabled={DisabledCheck(form.values["NotEditable"])}
                                            />
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <CustomTextField
                                                id="Q4DeviationComment"
                                                key={tabValue}
                                                label="Q4 Comment on Deviation"
                                                className="w-100"
                                                form={form}
                                                required
                                            />
                                        </td>
                                        <td>
                                            <CustomTextField
                                                id="Q4MitigationPlan"
                                                key={tabValue}
                                                label="Q4 Mitigation Plan"
                                                className="w-100"
                                                form={form}
                                                required
                                            />
                                        </td>
                                    </tr>

                                    <tr>
                                        <td>
                                            <CustomTextField
                                                id="FullYearAchievement"
                                                key={tabValue}
                                                label="Full Year Achievement"
                                                className="w-100"
                                                form={form}
                                                required
                                                disabled={DisabledCheck(form.values["NotEditable"])}
                                            />
                                        </td>
                                        <td>
                                            <CustomTextField
                                                id="AnnualDeviation"
                                                key={tabValue}
                                                label="Annual Deviation"
                                                className="w-100"
                                                form={form}
                                                required
                                            />
                                        </td>
                                    </tr>

                                    <tr>
                                        <td>
                                            <CustomTextField
                                                id="IndicatorResponsibility"
                                                key={tabValue}
                                                label="Indicator Responsibility"
                                                className="w-100"
                                                form={form}
                                                required
                                            />
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </TabPanel>
                    </FormTabContainer>
                </form>
            }
        </EntityForm>
    );
})

